import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormFieldAbstractComponent } from '../field-abstract/form-field.abstract.component';
import { FormFieldModel } from '../field-abstract/form-field.model';
@Component({
    selector: 'form-field',
    templateUrl: 'form-field.html',
    styleUrls: ['../field-abstract/field.scss', 'form-field.scss'],
    providers: [FormFieldModel],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormFieldComponent extends FormFieldAbstractComponent {}
